// views/LandingPage/components/LandingPageUsagesList/usageTypes.js
export const USAGE_TYPE_KEYS = {
  coworking: 'usages.coworking',
  privateOffice: 'usages.privateOffice',
  meetingRoom: 'usages.meetingRoom',
  seminarRoom: 'usages.seminarRoom',
  conferenceRoom: 'usages.conferenceRoom',
  teamBuildingSpace: 'usages.teamBuildingSpace',
  sharedOffice: 'usages.sharedOffice'
};

export const VALID_USAGE_TYPES = Object.keys(USAGE_TYPE_KEYS);